import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Form, Input, Row, Space } from "antd";
import { useEffect } from "react";
import { TipoSorteioModel } from "../../../../models/tipoSorteio/tipoSorteioModel";
import { atualizarTipoSorteio, cadastrarTipoSorteio, buscarTipoSorteio } from "../../../../services/tipoSorteioService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setModalCadastrarTipoSorteio } from "../../../../redux/slices/tipoSorteio/tipoSorteioSlice";

const CadastroTipoSorteio = () => {
  //estados globais
  const tipoSorteioState = useAppSelector((state) => state.tipoSorteio);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<TipoSorteioModel>();

  const editar = Object.values(tipoSorteioState.entity).length !== 0;

  useEffect(() => {
    if (editar) {
      form.setFieldsValue({ ...tipoSorteioState.entity });
    }
  }, [tipoSorteioState.entity]);

  const submit = (values: TipoSorteioModel) => {
    if (editar) {
      dispatch(
        atualizarTipoSorteio({
          value: {
            ...values,
            id: tipoSorteioState.entity.id,
          },
          busca: tipoSorteioState.busca,
        })
      );
    } else {
      dispatch(cadastrarTipoSorteio({ value: values, busca: tipoSorteioState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarTipoSorteio(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical">
      <Row gutter={12} justify="space-around">
        <Col span={24}>
          <Form.Item
            label="Denominacao"
            name="denominacao"
            rules={[
              {
                required: true,
                message: "Digite a denominação",
              },
            ]}
          >
            <Input type="text" placeholder="Digite a denominação" maxLength={100} />
          </Form.Item>
        </Col>
      </Row>
      <Divider></Divider>
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroTipoSorteio;
